import { mseApiDomain } from '@/utils/mseApiDomain';

const host = mseApiDomain();
const { VITE_BASE_API_PATH } = import.meta.env;
const BASE_API_PATH = VITE_BASE_API_PATH || 'creditclub';
const protocol = window.location.protocol;

export const MSE_API_BASE_URL = `${protocol}//${host}/${BASE_API_PATH}`;
export const MSE_HOST = `${protocol}//${window.location.host}`;
export const BROKER_BASE_URL = `${MSE_HOST}/money/broker`;
export const CSIS_BASE_URL = `${MSE_HOST}/credit`;

export const AUTH_LOGOUT_URL = `${MSE_HOST}/auth/logout`;
export const AUTH_CC_SESSION_URL = `${MSE_HOST}/auth/cc-session`;
export const BROKER_CARDS_BASE_URL = `${BROKER_BASE_URL}/credit-cards/v1`;
export const BROKER_LOANS_BASE_URL = `${BROKER_BASE_URL}/loans/v1`;
export const BROKER_SESSION_URL = `${BROKER_BASE_URL}/mse/v1/session`;
export const REF_DATA_URL = `${BROKER_BASE_URL}/mse/v1/reference-data-lookup`;

export const PROFILE_URL = `${CSIS_BASE_URL}/users/profile`;
export const RECONFIRM_DETAILS_URL = `${CSIS_BASE_URL}/users/reconfirmDetails`;
export const IS_VALID_PROFILE_URL = `${CSIS_BASE_URL}/users/is-valid-profile`;
export const KBA_QUESTIONS_URL = `${CSIS_BASE_URL}/kba/questions`;
export const KBA_VERIFY_URL = `${CSIS_BASE_URL}/kba/verify`;
export const SEND_OTP_URL = `${CSIS_BASE_URL}/otp/send`;
export const VERIFY_OTP_URL = `${CSIS_BASE_URL}/otp/verify`;
export const MORTGAGE_URL = `${CSIS_BASE_URL}/mortgage`;
export const AFFORDABILITY_URL = `${CSIS_BASE_URL}/affordability`;
export const AFFORDABILITY_REFRESH_URL = `${CSIS_BASE_URL}/affordability/refresh`;
export const ALERTS_URL = `${CSIS_BASE_URL}/alerts`;
export const ALERTS_UPDATE_URL = ALERTS_URL;
export const DELETE_URL = `${CSIS_BASE_URL}/users/delete-account`;

export const CREDIT_PROFILE_URL = `${CSIS_BASE_URL}/credit-profile`;
export const FULL_CREDIT_PROFILE_URL = `${CREDIT_PROFILE_URL}/full-report`;
export const EXISTS_OUTCOME_URL = `${CREDIT_PROFILE_URL}/customers/exists-outcome`;
export const FINANCIAL_ACCOUNT_URL = `${CREDIT_PROFILE_URL}/financial-account/details`;
export const DISPUTE_URL = `${CREDIT_PROFILE_URL}/dispute`;
export const IDENTIFY_URL = `${CREDIT_PROFILE_URL}/identify-profile`;

export const ADDRESS_LOOKUP_URL = `${MSE_HOST}/services/addresslookup/v1`;
export const FAQ_URL = `https://help.moneysavingexpert.com/en/`;

export const MSE_CARDS_RESULTS = '/eligibility/credit-cards/search/results/';
export const MSE_CARDS_QUESTION_SET = '/eligibility/credit-cards/search/';

export const MSE_LOANS_RESULTS = '/eligibility/loans-calculator/search/results/';
export const MSE_LOANS_QUESTION_SET = '/eligibility/loans-calculator/search/';
